// extracted by mini-css-extract-plugin
module.exports = {"legalLinks":"LegalLinks_legalLinks__DsEgq","legalLink":"LegalLinks_legalLink__xetEv"};